<template>
  <div class="form-group"
    :class="{'is-invalid-group':error || errorMessage}"
  >

  
  <div>
    <!-- <div class="input-group-prepend" v-if="icon">
      <span class="input-group-text">
        <feather :type="icon" class="icon-dual"></feather>
      </span>
    </div> -->
    <div class="textOnInput">
      <label class="form-control-label" for="inputText">{{ label }}</label>
      <input
        :name="name"
        :type="type"
        autocomplete="autocomplete"
        class="form-control form-box"
        :class="{ 'is-invalid': error || errorMessage, 'is-valid': !error && !errorMessage && isBlur }"
        :placeholder="placeholder"
        @input="$emit('input', $event.target.value)"
        @blur="onBlur"
        :value="value"
        :readonly="readonly"
        :disabled="disabled"
      />
    </div>
    </div>
    <div class="invalid-feedback" v-if="errorMessage">
      {{ errorMessage }}
    </div>
    <div class="invalid-feedback" v-else-if="error">
      Please provide a valid {{ name || label || 'input' }}
    </div>
    <div class="text-success" v-else-if="!error && !errorMessage && isBlur">
      {{ customizedMessage ? customizedMessage : 'Looks good!' }}
    </div>
    <div class="text-muted" v-if="help">
      {{ help }}
    </div>
    <!-- <ul 
        class="parsley-errors-list filled" 
        v-if="error"
      >
      <li>
          <div v-if="!required">This value is required.</div>
          <div v-if="!email">This value should be a valid email.</div>
      </li>
    </ul> -->
  </div>
</template>

<script>
export default {
  props:['type', 'placeholder', 'label', 'icon', 'name', 'autocomplete', 'value', 'required', 'error', 'errorMessage', 'help', 'max', 'readonly', 'disabled', 'customizedMessage'],
  data () {
    return {
      isBlur: false
    }
  },
  methods:{
    onBlur(){
      this.isBlur = false
      let val = parseFloat(this.$props.value)
      if(this.$props.max){
        if(val > this.$props.max){
          this.$props.value = this.$props.max
        }
      }

      // if(this.value) {
      //   this.isBlur = true
      // }
    }
  }
}
</script>

<style>
  /* input:is-valid {
    border:#2dc28c;
    content: "✓";
  } */
</style>

<!-- <style>
  .textOnInput {
      position: relative;
  }
  .textOnInput label {
      position: absolute;
      top: -15px;
      left: 23px;
      padding: 2px;
      z-index: 1;
  }
  .textOnInput label:after {
      content: " ";
      background-color: #fff;
      width: 100%;
      height: 13px;
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: -1;
  }
  label {
      font-size: 16px;
      font-weight: 500;
      display: inline-block;
      margin-bottom: .5rem;
  }
  .form-box {
      box-shadow: none !important;

  }
</style> -->